import Dropdown from "../../common/dropdown/Dropdown";
import {useContext} from "react";
import {OfficeContext} from "../../../state/OfficeContext";

const SelectOffice = () => {
    const {offices, selectedOffice, onSelect} = useContext(OfficeContext);
    const officeOptions = Object.keys(offices)
        .map(key => ({key, text: offices[key]}));
    const handleOfficeChange = ({key}) => {
        onSelect(key);
    }
    return (
        <Dropdown
            items={officeOptions}
            selectedText={offices[selectedOffice]}
            onChange={handleOfficeChange}
        />
    );
};

export default SelectOffice;